import { useState } from "react";

function ValueCard({ value, isActive, onClick }) {
  return (
    <div
      onClick={() => onClick(value.id)}
      className="relative group flex flex-col items-center text-center bg-white p-14 rounded-lg shadow-md hover:shadow-none transition-all duration-300 cursor-pointer w-full sm:w-80 md:w-96 mx-auto"
    >
      <div className="w-full h-1 mx-2 mb-4 bg-stone-500 rounded-full" />

      <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-2">
        {value.title}
      </h2>

      <div
        className={`absolute inset-0 bg-white px-4 sm:px-6 flex items-center justify-center text-sm sm:text-base text-gray-600 text-center rounded-lg transition-opacity duration-300 ${
          isActive ? "opacity-100 shadow-none hover:shadow-none" : "group-hover:opacity-100 opacity-0 shadow-md hover:shadow-none"
        }`}
      >
        <p>{value.fullDescription}</p>
      </div>
    </div>
  );
}

export default function OurMission() {
  const [activeCard, setActiveCard] = useState(null);

  const values = [
    {
      id: 1,
      title: "Education",
      fullDescription: `
      We aim to deliver quality education, 
      nurture problem-solving skills, 
      and foster lifelong learning opportunities for underprivileged communities. 

      Our efforts target systemic issues by building an informed society.`,
    },
    {
      id: 2,
      title: "Skill & Leadership Development",
      fullDescription: `
      We promote digital literacy and leadership development 
      for marginalized groups, including students with disabilities and low-income families. 

      We are using improved teaching methods to provide engaging and relevant learning resources.`,
    },
    {
      id: 3,
      title: "Healthcare Access",
      fullDescription: `
      We provide accessible and quality healthcare free of cost to those with limited resources. 

      Our goals include addressing general nutritional and health needs and 
      improving public health through advancing research, chronic disease
      management, health education.`,
    },
    {
      id: 4,
      title: "Community & Lifelong Learning",
      fullDescription: `
      We collaborate with local organizations, families, 
      and community members to create a supportive environment. 

      An important goal is to encourage continuous learning throughout their lives.`,
    },
  ];

  return (
    <section className="min-h-screen px-8 mb-20">
      <div className="max-w-6xl mx-auto bg-white p-12">
        <div className="text-center">
          <h1 className="what-we-do text-5xl font-bold text-sky-950">What We Do</h1>
          <p className="text-gray-500 italic text-sm mt-4 mb-12">
            Select a card to learn more.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-24 gap-y-24 mt-12">
          {values.map((value) => (
            <ValueCard
              key={value.id}
              value={value}
              isActive={activeCard === value.id}
              onClick={() =>
                setActiveCard(activeCard === value.id ? null : value.id)
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}
